// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__tPCNG","modal":"Modal_modal__k9pKt","slide-down":"Modal_slide-down__pW6HQ"};